import type { FilteredSchema, PlayerRoster } from '~/types'
import { playerRosterPassingStatsSchema } from '~/statistics/playerRosters/passing'
import { playerRosterReceivingStatsSchema } from '~/statistics/playerRosters/receiving'
import { playerRosterRushingStatsSchema } from '~/statistics/playerRosters/rushing'
import { playerRosterPuntReturnsStatsSchema } from '~/statistics/playerRosters/puntReturns'
import { playerRosterInterceptionsStatsSchema } from '~/statistics/playerRosters/interceptions'
import { playerRosterKickReturnsStatsSchema } from '~/statistics/playerRosters/kickReturns'
import { playerRosterAllPurposeYardageStatsSchema } from '~/statistics/playerRosters/allPurposeYardage'
import { playerRosterFieldGoalsStatsSchema } from '~/statistics/playerRosters/fieldGoals'
import { playerRosterPuntingStatsSchema } from '~/statistics/playerRosters/punting'
import { playerRosterKickoffsStatsSchema } from '~/statistics/playerRosters/kickoffs'
import { playerRosterDefenseStatsSchema } from '~/statistics/playerRosters/defense'

export enum PlayerStatsCategory {
  Passing = 'Passing',
  Rushing = 'Rushing',
  Receiving = 'Receiving',
  PuntReturns = 'Punt Returns',
  Interceptions = 'Interceptions',
  KickReturns = 'Kick Returns',
  AllPurposeYardage = 'All-Purpose Yardage',
  FieldGoals = 'Field Goals',
  Punting = 'Punting',
  Kickoffs = 'Kickoffs',
  Defense = 'Defense',
}

export const RosterPlayerStatsCategories: Record<PlayerStatsCategory, FilteredSchema<PlayerRoster.Model>> = {
  [PlayerStatsCategory.Passing]: playerRosterPassingStatsSchema,
  [PlayerStatsCategory.Rushing]: playerRosterRushingStatsSchema,
  [PlayerStatsCategory.Receiving]: playerRosterReceivingStatsSchema,
  [PlayerStatsCategory.PuntReturns]: playerRosterPuntReturnsStatsSchema,
  [PlayerStatsCategory.Interceptions]: playerRosterInterceptionsStatsSchema,
  [PlayerStatsCategory.KickReturns]: playerRosterKickReturnsStatsSchema,
  [PlayerStatsCategory.AllPurposeYardage]: playerRosterAllPurposeYardageStatsSchema,
  [PlayerStatsCategory.FieldGoals]: playerRosterFieldGoalsStatsSchema,
  [PlayerStatsCategory.Punting]: playerRosterPuntingStatsSchema,
  [PlayerStatsCategory.Kickoffs]: playerRosterKickoffsStatsSchema,
  [PlayerStatsCategory.Defense]: playerRosterDefenseStatsSchema,
}
